
<div v-if="visible" ref="alert" class="cp-alert">
  <div class="box-mask">
    <div class="box-container">
      <!-- <div class="box-header">
        <div class="box-title">{{ title }}</div>
      </div> -->
      <div class="box-content" v-html="text"></div>
    </div>
  </div>
</div>
